import Styled from "./styles";
const SubPageHeader = ({ titleBlue, titleBlack }) => {
  return (
    <Styled>
      <div className="sub-page-header-container" id="main">
        <div className="sub-headers">
          <div className="title-blue">{titleBlue}</div>
          <div className="title-black">{titleBlack}</div>
        </div>
      </div>
    </Styled>
  );
};
export default SubPageHeader;
